// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_jlpt_levels_n1_description = /** @type {(inputs: {}) => string} */ () => {
	return `Achieve fluency! Master high-level reading, professional language, and the subtle nuances of Japanese expression.`
};

const id_jlpt_levels_n1_description = /** @type {(inputs: {}) => string} */ () => {
	return `Raih kefasihan! Kuasai bacaan tingkat tinggi, bahasa profesional, dan nuansa halus dalam ekspresi bahasa Jepang.`
};

const ja_jlpt_levels_n1_description = /** @type {(inputs: {}) => string} */ () => {
	return `流暢な日本語を習得！高度な読解力、専門的な言葉遣い、そして日本語表現の微妙なニュアンスをマスターしましょう。`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "id" | "ja" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const jlpt_levels_n1_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jlpt_levels_n1_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("jlpt_levels_n1_description", locale)
	if (locale === "en") return en_jlpt_levels_n1_description(inputs)
	if (locale === "id") return id_jlpt_levels_n1_description(inputs)
	return ja_jlpt_levels_n1_description(inputs)
};
export { jlpt_levels_n1_description as "jlpt_levels.n1.description" }